"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("../../../utils/styled-components"));

var _styleGenerators = require("../../../utils/styleGenerators");

var _withTemplateInput = _interopRequireDefault(require("../../../hoc/withTemplateInput"));

var _Text = _interopRequireDefault(require("../../Text"));

var _fieldItem = _interopRequireDefault(require("../fieldItem"));

var _excluded = ["input", "label", "name", "className", "icon", "style", "onChange", "value", "inputRef", "disabled", "error", "htmlType", "resizable"];

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var TextAreaContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  -webkit-font-feature-settings: \"tnum\";\n  font-feature-settings: \"tnum\";\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  text-align: start;\n"])));

var TextAreaSuffix = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  right: 0px;\n  height: 100%;\n  & > img,\n  & > i {\n    height: 100%;\n  }\n"])));

var StyledTextArea = (0, _styledComponents["default"])(function (_ref) {
  var input = _ref.input,
      label = _ref.label,
      name = _ref.name,
      className = _ref.className,
      icon = _ref.icon,
      style = _ref.style,
      onChange = _ref.onChange,
      value = _ref.value,
      inputRef = _ref.inputRef,
      disabled = _ref.disabled,
      error = _ref.error,
      htmlType = _ref.htmlType,
      resizable = _ref.resizable,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_fieldItem["default"], {
    type: input.title,
    label: label
  }, /*#__PURE__*/_react["default"].createElement(TextAreaContainer, null, /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, props, {
    name: name || "",
    type: htmlType,
    className: className,
    value: value,
    style: style,
    onChange: onChange,
    placeholder: props.placeholder,
    ref: inputRef,
    disabled: disabled
  })), icon && /*#__PURE__*/_react["default"].createElement(TextAreaSuffix, null, icon)), error && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    type: input.error
  }, error));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$input = _ref2.input,
      field = _ref2$input.field,
      placeholder = _ref2$input.placeholder;
  var inputStyles = [];

  if (field) {
    inputStyles.push((0, _styleGenerators.styleObjectToString)(field));
  }

  if (placeholder) {
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::-webkit-input-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::-moz-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)(':-ms-input-placeholder', placeholder));
    inputStyles.push((0, _styleGenerators.styleObjectToCSSString)('::placeholder', placeholder));
  }

  return inputStyles.join();
});

var _default = (0, _withTemplateInput["default"])(StyledTextArea);

exports["default"] = _default;